<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <link-table-cell-normal
            :render-func="renderFunc"
            :scope-slot-func="scopeSlotFunc"
            :text="showRow[field]"
            :data="scopeSlotData"/>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: "lv-column-item",
        components: {LvScopeSlot, LvColumnText},
        mixins: [ColumnItemMixin]
    }
</script>
